<template>

	<div class="pay_dialog no-trans">
		<el-dialog title="微信支付" :visible.sync="shows" @closed="onclosed" :close-on-click-modal="false" :close-on-press-escape="false" >
            <div class="qrcode_img">
                <img :src="qrcode" alt="">
            </div>
            
		</el-dialog>

	</div>
</template>
<script>
	export default {
		name: "pay_dialog",
		props: {
			 
		},
		data() {
			return {
				shows: false,
                qrcode:'',//支付二维码
                path:{},
			 

			};
		},
        created() {


		},
        beforeDestroy(){
            this.shows=false
        },
		methods: {
			onclosed(){
				this.shows= false
				 
			},	

			//打开
			handle_open(res_data,data,path) {
				console.log('res_data,data,path',res_data,data,path)
                this.qrcode=res_data.qrcode
                this.path=path
				this.shows = true
                this.get_pay_info(data)
			},


            get_pay_info(data){
                this.loading=true
                this.$api("checkOrder", {
                    order_no:data,//

                }, "get").then((res) => {
                    this.loading = false
                   
                    if (res.code == 1) {
                        console.log('微信支付信息',res)
                        if(!res.data){
                            if(this.shows){
                                setTimeout(() => {
                                    this.get_pay_info(data)
                                }, 2000)
                            }
                        }else{
                            this.$router.push(this.path)
                        }
                     
                        
                    } else {
                        alertErr(res.msg)
                    }
                });
            },
			//关闭    
			handle_close() {
				this.shows = false

			},
			 
			 
			 
		},
		computed: {},

		watch: {

		},


		


	};
</script>

<style scoped lang="less">
	.pay_dialog {
		/deep/.el-dialog {
			width: 600px;
		}

		/deep/.el-dialog__header {
			background: #F2F5FA !important;
		}
        .qrcode_img{
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 300px;
            }
        }

		 

	}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .pay_dialog.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .pay_dialog.no-trans /deep/ .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .pay_dialog.no-trans .qrcode_img {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .pay_dialog.no-trans .qrcode_img img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
}
</style>
